"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckMobileOtpToken = exports.RefreshMobileOtpLogin = exports.CompleteMobileOtpLogin = exports.InitiateMobileOtpLogin = exports.FormSG = exports.WogSsoLogin = exports.WogSsoCheckToken = exports.WogSsoRefreshToken = exports.JwtSsoLogin = exports.UserRolesUnified = exports.RefreshTokenUnified = exports.CheckTokenUnified = exports.SystemLogout = exports.CheckGuestEnhancedToken = exports.RefreshGuestEnhancedLogin = exports.CompleteGuestEnhancedLogin = exports.InitiateGuestEnhancedLogin = exports.CheckGuestToken = exports.CompleteGuestLogin = exports.InitiateGuestLogin = exports.NDIResumeConsent = exports.DynamicLink = exports.RemoveToken = exports.RefreshToken = exports.GenerateToken = exports.CheckToken = void 0;
const checkGuestTokenDomain = __importStar(require("./check-guest-token/check-guest-token-domain"));
const checkGuestEnhancedTokenDomain = __importStar(require("./check-guest-enhanced-token/check-guest-enhanced-token-domain"));
const checkTokenUnifiedDomain = __importStar(require("./check-token-unified/check-token-unified-domain"));
const checkTokenUnifiedTransformer = __importStar(require("./check-token-unified/transformer/check-token-unified-domain-transformer"));
const checkTokenDomain = __importStar(require("./check-token/check-token-api-domain"));
const checkTokenTransformer = __importStar(require("./check-token/transformer/check-token-api-domain-transformer"));
const completeGuestLoginDomain = __importStar(require("./complete-guest-login/complete-guest-login-api-domain"));
const completeGuestEnhancedLoginDomain = __importStar(require("./complete-guest-enhanced-login/complete-guest-enhanced-login-api-domain"));
const generateDynamicLink = __importStar(require("./dynamic-link/dynamic-link-api-domain"));
const generateDynamicLinkTransformer = __importStar(require("./dynamic-link/transfomer"));
const generateTokenDomain = __importStar(require("./generate-token/generate-token-api-domain"));
const generateTokenTransformer = __importStar(require("./generate-token/transformer/generate-token-api-domain-transformer"));
const initiateGuestLoginDomain = __importStar(require("./initiate-guest-login/initiate-guest-login-api-domain"));
const initiateGuestEnhancedLoginDomain = __importStar(require("./initiate-guest-enhanced-login/initiate-guest-enhanced-login-api-domain"));
const ndiResumeConsentDomain = __importStar(require("./ndi-resume-consent/ndi-resume-consent-api-domain"));
const refreshTokenDomain = __importStar(require("./refresh-token/refresh-token-api-domain"));
const refreshTokenTransformer = __importStar(require("./refresh-token/transformer/refresh-token-api-domain-transformer"));
const removeTokenDomain = __importStar(require("./remove-token/remove-token-api-domain"));
const systemLogoutDomain = __importStar(require("./system-logout/system-logout-api-domain"));
const systemLogoutTransformer = __importStar(require("./system-logout/transformer/system-logout-api-domain-transformer"));
const checkWogUserTokenDomain = __importStar(require("./check-wog-user-token/check-wog-user-token-domain"));
const jwtSsoDomain = __importStar(require("./jwt-sso/jwt-sso-api-domain"));
const wogSsoDomain = __importStar(require("./wog-sso/wog-sso-api-domain"));
const formSGDomain = __importStar(require("./formsg/formsg-api-domain"));
const formSGTransformer = __importStar(require("./formsg/transformer"));
const userRolesUnifiedTransformer = __importStar(require("./user-roles-unified/transformer/user-roles-unified-domain-transformer"));
const userRolesUnifiedDomain = __importStar(require("./user-roles-unified/user-roles-unified-api-domain"));
const initiateMobileOtpLoginDomain = __importStar(require("./initiate-mobile-otp-login/initiate-mobile-otp-login-api-domain"));
const completeMobileOtpLoginDomain = __importStar(require("./complete-mobile-otp-login/complete-mobile-otp-login-api-domain"));
const checkMobileOtpTokenDomain = __importStar(require("./check-mobile-otp-token/check-mobile-otp-token-domain"));
// =============================================================================
// Re-export
// =============================================================================
__exportStar(require("./common/enums"), exports);
__exportStar(require("./common/MOLGuestTokenData"), exports);
__exportStar(require("./common/MOLUserAuthCookieKey"), exports);
__exportStar(require("./common/MOLUserTokenData"), exports);
__exportStar(require("./common/SsoUserAuthLevel"), exports);
__exportStar(require("./auth-roles"), exports);
__exportStar(require("./auth-user-otp"), exports);
__exportStar(require("./app-check"), exports);
var CheckToken;
(function (CheckToken) {
    CheckToken.method = "GET";
    CheckToken.route = "/auth-forwarder/api/v1/check-token";
    CheckToken.routeV2 = "/auth-forwarder/api/v2/check-token";
    CheckToken.routeV3 = "/auth-forwarder/api/auth-user/check-token/v3";
    CheckToken.Domain = checkTokenDomain;
    CheckToken.Transformers = checkTokenTransformer;
})(CheckToken || (exports.CheckToken = CheckToken = {}));
var GenerateToken;
(function (GenerateToken) {
    GenerateToken.method = "POST";
    GenerateToken.route = "/auth-forwarder/api/v1/generate-token";
    GenerateToken.Domain = generateTokenDomain;
    GenerateToken.Transformers = generateTokenTransformer;
})(GenerateToken || (exports.GenerateToken = GenerateToken = {}));
var RefreshToken;
(function (RefreshToken) {
    RefreshToken.method = "POST";
    RefreshToken.route = "/auth-forwarder/api/v1/refresh-token";
    RefreshToken.routeV2 = "/auth-forwarder/api/refresh-token/v2";
    RefreshToken.Domain = refreshTokenDomain;
    RefreshToken.Transformers = refreshTokenTransformer;
})(RefreshToken || (exports.RefreshToken = RefreshToken = {}));
var RemoveToken;
(function (RemoveToken) {
    RemoveToken.method = "POST";
    RemoveToken.route = "/auth-forwarder/api/v1/remove-token";
    RemoveToken.Domain = removeTokenDomain;
})(RemoveToken || (exports.RemoveToken = RemoveToken = {}));
var DynamicLink;
(function (DynamicLink) {
    DynamicLink.method = "POST";
    DynamicLink.route = "/auth-forwarder/api/dynamic-link/v1/generate";
    DynamicLink.Domain = generateDynamicLink;
    DynamicLink.Transformers = generateDynamicLinkTransformer;
})(DynamicLink || (exports.DynamicLink = DynamicLink = {}));
var NDIResumeConsent;
(function (NDIResumeConsent) {
    NDIResumeConsent.method = "POST";
    NDIResumeConsent.route = "/auth-forwarder/api/auth-user/consent/resume/v2";
    NDIResumeConsent.Domain = ndiResumeConsentDomain;
})(NDIResumeConsent || (exports.NDIResumeConsent = NDIResumeConsent = {}));
var InitiateGuestLogin;
(function (InitiateGuestLogin) {
    InitiateGuestLogin.method = "POST";
    InitiateGuestLogin.route = "/auth-forwarder/api/auth-guest/login/initiate/v1";
    InitiateGuestLogin.Domain = initiateGuestLoginDomain;
})(InitiateGuestLogin || (exports.InitiateGuestLogin = InitiateGuestLogin = {}));
var CompleteGuestLogin;
(function (CompleteGuestLogin) {
    CompleteGuestLogin.method = "POST";
    CompleteGuestLogin.route = "/auth-forwarder/api/auth-guest/login/complete/v1";
    CompleteGuestLogin.Domain = completeGuestLoginDomain;
})(CompleteGuestLogin || (exports.CompleteGuestLogin = CompleteGuestLogin = {}));
var CheckGuestToken;
(function (CheckGuestToken) {
    CheckGuestToken.method = "GET";
    CheckGuestToken.route = "/auth-forwarder/api/auth-guest/check-token/v1";
    CheckGuestToken.Domain = checkGuestTokenDomain;
})(CheckGuestToken || (exports.CheckGuestToken = CheckGuestToken = {}));
var InitiateGuestEnhancedLogin;
(function (InitiateGuestEnhancedLogin) {
    InitiateGuestEnhancedLogin.method = "POST";
    InitiateGuestEnhancedLogin.route = "/auth-forwarder/api/auth-guest-enhanced/login/initiate/v1";
    InitiateGuestEnhancedLogin.Domain = initiateGuestEnhancedLoginDomain;
})(InitiateGuestEnhancedLogin || (exports.InitiateGuestEnhancedLogin = InitiateGuestEnhancedLogin = {}));
var CompleteGuestEnhancedLogin;
(function (CompleteGuestEnhancedLogin) {
    CompleteGuestEnhancedLogin.method = "POST";
    CompleteGuestEnhancedLogin.route = "/auth-forwarder/api/auth-guest-enhanced/login/complete/v1";
    CompleteGuestEnhancedLogin.Domain = completeGuestEnhancedLoginDomain;
})(CompleteGuestEnhancedLogin || (exports.CompleteGuestEnhancedLogin = CompleteGuestEnhancedLogin = {}));
var RefreshGuestEnhancedLogin;
(function (RefreshGuestEnhancedLogin) {
    RefreshGuestEnhancedLogin.method = "POST";
    RefreshGuestEnhancedLogin.route = "/auth-forwarder/api/auth-guest-enhanced/refresh-token/v1";
})(RefreshGuestEnhancedLogin || (exports.RefreshGuestEnhancedLogin = RefreshGuestEnhancedLogin = {}));
var CheckGuestEnhancedToken;
(function (CheckGuestEnhancedToken) {
    CheckGuestEnhancedToken.method = "GET";
    CheckGuestEnhancedToken.route = "/auth-forwarder/api/auth-guest-enhanced/check-token/v1";
    CheckGuestEnhancedToken.Domain = checkGuestEnhancedTokenDomain;
})(CheckGuestEnhancedToken || (exports.CheckGuestEnhancedToken = CheckGuestEnhancedToken = {}));
var SystemLogout;
(function (SystemLogout) {
    SystemLogout.method = "POST";
    SystemLogout.route = "/auth-forwarder/api/auth-user/logout/system/v1";
    SystemLogout.Domain = systemLogoutDomain;
    SystemLogout.Transformers = systemLogoutTransformer;
})(SystemLogout || (exports.SystemLogout = SystemLogout = {}));
var CheckTokenUnified;
(function (CheckTokenUnified) {
    CheckTokenUnified.method = "GET";
    CheckTokenUnified.route = "/auth-forwarder/api/auth-unified/check-token/v1";
    CheckTokenUnified.Domain = checkTokenUnifiedDomain;
    CheckTokenUnified.Transformers = checkTokenUnifiedTransformer;
})(CheckTokenUnified || (exports.CheckTokenUnified = CheckTokenUnified = {}));
var RefreshTokenUnified;
(function (RefreshTokenUnified) {
    RefreshTokenUnified.method = "POST";
    RefreshTokenUnified.route = "/auth-forwarder/api/auth-unified/refresh-token/v1";
})(RefreshTokenUnified || (exports.RefreshTokenUnified = RefreshTokenUnified = {}));
var UserRolesUnified;
(function (UserRolesUnified) {
    UserRolesUnified.method = "GET";
    UserRolesUnified.route = "/auth-forwarder/api/auth-unified/user-roles/v1";
    UserRolesUnified.Domain = userRolesUnifiedDomain;
    UserRolesUnified.Transformers = userRolesUnifiedTransformer;
})(UserRolesUnified || (exports.UserRolesUnified = UserRolesUnified = {}));
var JwtSsoLogin;
(function (JwtSsoLogin) {
    JwtSsoLogin.method = "POST";
    JwtSsoLogin.route = "/auth-forwarder/api/auth-jwt-sso/login/v1";
    JwtSsoLogin.Domain = jwtSsoDomain;
})(JwtSsoLogin || (exports.JwtSsoLogin = JwtSsoLogin = {}));
var WogSsoRefreshToken;
(function (WogSsoRefreshToken) {
    WogSsoRefreshToken.method = "POST";
    WogSsoRefreshToken.route = "/auth-forwarder/api/auth-wog-user/refresh-token/v1";
    WogSsoRefreshToken.Domain = refreshTokenDomain;
})(WogSsoRefreshToken || (exports.WogSsoRefreshToken = WogSsoRefreshToken = {}));
var WogSsoCheckToken;
(function (WogSsoCheckToken) {
    WogSsoCheckToken.method = "GET";
    WogSsoCheckToken.route = "/auth-forwarder/api/auth-wog-user/check-token/v1";
    WogSsoCheckToken.Domain = checkWogUserTokenDomain;
})(WogSsoCheckToken || (exports.WogSsoCheckToken = WogSsoCheckToken = {}));
var WogSsoLogin;
(function (WogSsoLogin) {
    WogSsoLogin.method = "GET";
    WogSsoLogin.route = "/auth-forwarder/api/auth-wog-user/authorize/v1";
    WogSsoLogin.Domain = wogSsoDomain;
})(WogSsoLogin || (exports.WogSsoLogin = WogSsoLogin = {}));
var FormSG;
(function (FormSG) {
    FormSG.method = "POST";
    FormSG.Domain = formSGDomain;
    FormSG.Transformers = formSGTransformer;
})(FormSG || (exports.FormSG = FormSG = {}));
var InitiateMobileOtpLogin;
(function (InitiateMobileOtpLogin) {
    InitiateMobileOtpLogin.method = "POST";
    InitiateMobileOtpLogin.route = "/auth-forwarder/api/auth-mobile-otp/login/initiate/v1";
    InitiateMobileOtpLogin.Domain = initiateMobileOtpLoginDomain;
})(InitiateMobileOtpLogin || (exports.InitiateMobileOtpLogin = InitiateMobileOtpLogin = {}));
var CompleteMobileOtpLogin;
(function (CompleteMobileOtpLogin) {
    CompleteMobileOtpLogin.method = "POST";
    CompleteMobileOtpLogin.route = "/auth-forwarder/api/auth-mobile-otp/login/complete/v1";
    CompleteMobileOtpLogin.Domain = completeMobileOtpLoginDomain;
})(CompleteMobileOtpLogin || (exports.CompleteMobileOtpLogin = CompleteMobileOtpLogin = {}));
var RefreshMobileOtpLogin;
(function (RefreshMobileOtpLogin) {
    RefreshMobileOtpLogin.method = "POST";
    RefreshMobileOtpLogin.route = "/auth-forwarder/api/auth-mobile-otp/refresh-token/v1";
})(RefreshMobileOtpLogin || (exports.RefreshMobileOtpLogin = RefreshMobileOtpLogin = {}));
var CheckMobileOtpToken;
(function (CheckMobileOtpToken) {
    CheckMobileOtpToken.method = "GET";
    CheckMobileOtpToken.route = "/auth-forwarder/api/auth-mobile-otp/check-token/v1";
    CheckMobileOtpToken.Domain = checkMobileOtpTokenDomain;
})(CheckMobileOtpToken || (exports.CheckMobileOtpToken = CheckMobileOtpToken = {}));
//# sourceMappingURL=index.js.map